<form [formGroup]="form" (ngSubmit)="$event.preventDefault()">
  <div class="row">
    <rask-input aid="inputNamn" class="col-md-6 col-lg-5" label="{{'HANDELSSORTIMENT_DETAIL_NAMN' | translate}}"
      [required]="true" formControlName="namn" [rule]="validationContext.current.handelssortimentNamn">
    </rask-input>
  </div>
  <div class="row">
    <div class="col-md-3 col-lg-2">
      <label for="fieldBeteckning" class="col-form-label" translate>HANDELSSORTIMENT_DETAIL_BETECKNING</label>
      <div class="controls">
        <span id="fieldBeteckning" class="form-control-static">{{handelssortiment.beteckning}}</span>
      </div>
    </div>
    <div class="col-md-3 col-lg-2">
      <label for="fieldSkapadAv" class="col-form-label" translate>HANDELSSORTIMENT_DETAIL_SKAPAD_AV</label>
      <div>
        <span id="fieldSkapadAv" class="form-control-static">{{handelssortiment.skapadAv}}</span>
      </div>
    </div>
    <div class="col-md-2 col-lg-1">
      <label for="inputAktiv" class="col-form-label" translate>HANDELSSORTIMENT_DETAIL_AKTIV</label>
      <div class="custom-control custom-checkbox">
        <input class="custom-control-input" id="inputAktiv" type="checkbox" formControlName="aktiv">
        <label class="custom-control-label" for="inputAktiv"></label>
      </div>
    </div>
    <div class="controls col-md-2">
      @if (canAddRelated()) {
        <div>
          <label for="fieldRelateraHandelssortiment" class="col-form-label">
            <span translate>HANDELSSORTIMENT_DETAIL_RELATERA_TILL_HANDELSSORTIMENT_LABEL</span>
            <i class="fas fa-info-circle ps-1 relatera-till-handelssortiment-tooltip-label"
              style="cursor: default"
              ngbPopover="{{ 'HANDELSSORTIMENT_DETAIL_RELATERA_TILL_HANDELSSORTIMENT_LABEL_TOOLTIP' | translate}}"
            triggers="mouseenter:mouseleave"></i>
          </label>
          <rask-add-button class="block" (click)="showRelateraHandelssortiment()">
          {{'DEFAULT_BUTTON_LABEL_LAGG_TILL' | translate}}</rask-add-button>
        </div>
      }

      @if (relateratHandelssortimentVisible) {
        <rask-selector
          infoText="{{'HANDELSSORTIMENT_DETAIL_RELATERA_TILL_HANDELSSORTIMENT_LABEL_TOOLTIP' | translate}}"
          class="col-12" label="{{'HANDELSSORTIMENT_DETAIL_RELATERA_TILL_HANDELSSORTIMENT_LABEL' | translate}}"
          formControlName="relateratHandelssortimentId"
          [formatter]="outputFormatter" [debounceTime]="300" [minCharacters]="3"
          [placeholder]="'DEFAULT_TYPE_AHEAD_HELP_TEXT' | translate"
          [getSelectionFromModel]="getInitSelectedRelateratHandelssortiment"
          [search]="searchForRelaterbaraHandelssortiment" [viewFormatter]="formatter">
        </rask-selector>
      }

      @if (relateradeHandelssortiment && relateradeHandelssortiment.length > 0) {
        <div>
          <label for="relateradeHandelssortiment" class="col-form-label">
            <span id="relateradeHandelssortiment"
            translate>HANDELSSORTIMENT_DETAIL_RELATERADE_HANDELSSORTIMENT_LABEL</span>
            <i class="fas fa-info-circle ps-1"
              style="cursor: default"
              ngbPopover="{{ 'HANDELSSORTIMENT_DETAIL_RELATERADE_HANDELSSORTIMENT_LABEL_TOOLTIP' | translate}}"
            triggers="mouseenter:mouseleave"></i>
          </label>
          @for (hs of relateradeHandelssortiment; track hs) {
            <a [routerLink]="['/handelssortiment', hs.id]" class="relatedLink"
            >{{hs.namn}}</a>
          }
        </div>
      }
    </div>

    @if (!foradlingsHandelssortiment || foradlingsHandelssortiment.length < 1) {
      <div class="controls col-md-2">
        <rask-selector
          infoText="{{'HANDELSSORTIMENT_DETAIL_RAVARA_HANDELSSORTIMENT_LABEL_TOOLTIP' | translate}}"
          class="col-12" label="{{'HANDELSSORTIMENT_DETAIL_RAVARA_HANDELSSORTIMENT_LABEL' | translate}}"
          formControlName="ravaruHandelssortimentId"
          [formatter]="outputFormatter"
          [placeholder]="'DEFAULT_TYPE_AHEAD_HELP_TEXT' | translate"
          [getSelectionFromModel]="getInitSelectedHandelssortiment"
          [exclude]="[handelssortiment]"
          [search]="searchForHandelssortiment" [viewFormatter]="formatter">
        </rask-selector>
      </div>
    }
    <div class="controls col-md-2 col-lg-1">
      <rask-textmultiline label="Omfattas ej av certifikat"
        class="custom-text"
        infoText="Handelssortiment ingår inte i Sveaskogs spårbarhetscertifikat">
        <div class="custom-control custom-checkbox">
          <input class="custom-control-input" id="inputOcertifierat" type="checkbox"
            formControlName="ocertifierat">
          </div>
        </rask-textmultiline>
      </div>
    </div>
  </form>
  <rask-show-hide [textOpen]="'DEFAULT_DOLJ_LOGG' | translate" [textClosed]="'DEFAULT_VISA_LOGG' | translate">
    @if (handelssortiment && handelssortiment.id) {
      <rask-data-change-log table="Handelssortiment"
      [referenceId]="handelssortiment.id"></rask-data-change-log>
    }
  </rask-show-hide>